import React from 'react'

const KeyedCipherTheory = () => {
    return (
        <div>
            <ul>
                <li>
                    <p>
                    Keyed transposition ciphers operate on the principle of rearranging the order of characters in a plaintext message based on a predetermined key.
                    </p>
                </li>
                <li>
                    <p>
                    The key determines the permutation pattern used for encryption and decryption.
                    </p>
                </li>
                <li>
                    <p>
                    The history of keyed transposition ciphers dates back to ancient times, with variations of transposition ciphers being used by various civilizations for secret communication. However, the specific concept of a keyed transposition cipher, where a key is used to determine the permutation pattern, gained prominence during the Renaissance period.
                    </p>
                </li>
                <li>
                    <p>
                    One notable figure associated with the development of keyed transposition ciphers is Johannes Trithemius, a German cryptographer and abbot, who lived during the 15th and 16th centuries. Trithemius is renowned for his work "Polygraphia," published in 1518, where he introduced various cryptographic techniques, including keyed transposition ciphers.
                    </p>
                </li>
                <li>
                    <p>
                    Keyed transposition ciphers offer a moderate level of security, especially when combined with other cryptographic techniques. The strength of the encryption largely depends on the complexity and randomness of the key chosen.
                    </p>
                </li>
            </ul>
        </div>
    )
}

export default KeyedCipherTheory